// events emitted to angular used by superclasses of Member
const MEMBER_EVENT = {
  CREATE: 'CreateMember',
  DELETE: 'DeleteMember',
  UPDATE: 'UpdateMember',
};
const MODEL_CACHE_ID = 'member/Member';

export {MEMBER_EVENT, MODEL_CACHE_ID};
